<template>
  <header class="site-header">
    <div class="header-inner">
      <div class="brand">
        <span class="logo">刊期日更网</span>
<!--        <span class="domain domain-pc">jiankanzhijia.com</span>-->
      </div>
      <button type="button" class="menu-btn" aria-label="菜单" @click="menuOpen = !menuOpen">
        <span class="menu-icon"></span>
      </button>
      <nav class="main-nav">
        <a href="javascript:;" class="nav-item active">首页</a>
<!--        <a href="javascript:;" class="nav-item">上传期刊</a>-->
<!--        <a href="javascript:;" class="nav-item">资源合作</a>-->
<!--        <a href="javascript:;" class="nav-item">有奖纠错</a>-->
<!--        <a href="javascript:;" class="nav-item">医学专区</a>-->
<!--        <a href="javascript:;" class="nav-item">学报专区</a>-->
<!--        <a href="javascript:;" class="nav-item">AI找刊</a>-->
      </nav>
      <div class="header-right">
<!--        <button type="button" class="btn btn-outline">旧版入口</button>-->
<!--        <button type="button" class="btn btn-outline">切换简洁版</button>-->
<!--        <select class="header-select"><option>价格部分隐藏</option></select>-->
        <select class="header-select theme-select" :value="theme" @change="onThemeChange">
          <option value="warm">暖色版</option>
          <option value="fresh">清新版</option>
        </select>
        <template v-if="user">
          <span class="user-name">{{ user.nickname || user.username }}</span>
          <a href="javascript:;" class="login-link" @click.prevent="onLogout">退出</a>
        </template>
        <a v-else href="javascript:;" class="login-link" @click.prevent="onLogin">点击登录</a>
      </div>
    </div>
    <div v-if="menuOpen" class="nav-overlay" @click="menuOpen = false"></div>
    <div class="nav-drawer" :class="{ open: menuOpen }">
      <div class="drawer-nav">
        <a href="javascript:;" class="nav-item active" @click="menuOpen = false">首页</a>
<!--        <a href="javascript:;" class="nav-item" @click="menuOpen = false">上传期刊</a>-->
<!--        <a href="javascript:;" class="nav-item" @click="menuOpen = false">资源合作</a>-->
<!--        <a href="javascript:;" class="nav-item" @click="menuOpen = false">有奖纠错</a>-->
<!--        <a href="javascript:;" class="nav-item" @click="menuOpen = false">医学专区</a>-->
<!--        <a href="javascript:;" class="nav-item" @click="menuOpen = false">学报专区</a>-->
<!--        <a href="javascript:;" class="nav-item" @click="menuOpen = false">AI找刊</a>-->
      </div>
      <div class="drawer-theme">
        <span class="drawer-theme-label">主题</span>
        <button type="button" class="drawer-theme-btn" :class="{ active: theme === 'warm' }" @click="onThemeChange({ target: { value: 'warm' } })">暖色版</button>
        <button type="button" class="drawer-theme-btn" :class="{ active: theme === 'fresh' }" @click="onThemeChange({ target: { value: 'fresh' } })">清新版</button>
      </div>
      <template v-if="user">
        <span class="drawer-user">{{ user.nickname || user.username }}</span>
        <a href="javascript:;" class="drawer-login" @click.prevent="onLogout">退出登录</a>
      </template>
      <a v-else href="javascript:;" class="drawer-login" @click.prevent="onLogin">点击登录</a>
    </div>
  </header>
</template>

<script>
import { ref, onMounted } from 'vue'
import { getTheme, setTheme } from '../utils/theme'

export default {
  name: 'PageHeader',
  props: {
    user: { type: Object, default: null }
  },
  emits: ['login', 'logout'],
  setup(props, { emit }) {
    const menuOpen = ref(false)
    const theme = ref(getTheme())
    function onLogin() {
      menuOpen.value = false
      emit('login')
    }
    function onLogout() {
      menuOpen.value = false
      emit('logout')
    }
    function onThemeChange(e) {
      const value = e.target && e.target.value
      if (value) {
        setTheme(value)
        theme.value = value
      }
    }
    onMounted(() => {
      theme.value = getTheme()
    })
    return { menuOpen, theme, onLogin, onLogout, onThemeChange }
  }
}
</script>

<style scoped>
.site-header {
  background: #fff;
  border-bottom: 1px solid var(--color-border);
  box-shadow: 0 1px 2px rgba(0,0,0,.05);
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}
.brand {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.logo {
  font-size: 20px;
  font-weight: 700;
  color: #c00;
}
.domain {
  font-size: 12px;
  color: var(--color-text-muted);
}
.main-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
  flex-wrap: wrap;
}
.nav-item {
  padding: 6px 12px;
  color: var(--color-text-secondary);
  font-size: 14px;
}
.nav-item:hover, .nav-item.active { color: var(--color-primary); }
.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.btn {
  padding: 6px 12px;
  border-radius: var(--radius);
  font-size: 12px;
}
.btn-outline {
  border: 1px solid var(--color-border);
  background: #fff;
  color: var(--color-text-secondary);
}
.header-select {
  padding: 6px 10px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  font-size: 12px;
  color: var(--color-text-secondary);
  background: #fff;
}
.login-link { font-size: 14px; }
.user-name { font-size: 13px; color: var(--color-text-secondary); margin-right: 8px; }
.drawer-user { display: block; padding: 12px 0; font-size: 14px; color: #333; }

/* 移动端：汉堡菜单 + 侧滑抽屉 */
.menu-btn {
  display: none;
  width: var(--touch-min);
  height: var(--touch-min);
  padding: 0;
  border: none;
  background: none;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.menu-icon {
  width: 22px;
  height: 2px;
  background: var(--color-text);
  box-shadow: 0 7px 0 var(--color-text), 0 -7px 0 var(--color-text);
}
.nav-overlay {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 998;
  background: rgba(0,0,0,.4);
}
.nav-drawer {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  max-width: 85vw;
  height: 100vh;
  height: 100dvh;
  z-index: 999;
  background: #fff;
  box-shadow: -2px 0 12px rgba(0,0,0,.15);
  transform: translateX(100%);
  transition: transform 0.25s ease;
  padding: calc(12px + var(--safe-top)) 20px 20px;
  padding-bottom: calc(20px + var(--safe-bottom));
  flex-direction: column;
}
.nav-drawer.open { transform: translateX(0); }
.drawer-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.drawer-nav .nav-item {
  padding: 14px 0;
  font-size: 15px;
  border-bottom: 1px solid #f0f0f0;
}
.drawer-theme {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 8px;
}
.drawer-theme-label { font-size: 13px; color: #999; margin-right: 10px; }
.drawer-theme-btn {
  margin-right: 8px;
  padding: 6px 12px;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: #fff;
  font-size: 13px;
  color: var(--color-text-secondary);
}
.drawer-theme-btn.active {
  border-color: var(--color-primary);
  background: var(--color-primary);
  color: #fff;
}
.drawer-login {
  margin-top: auto;
  padding: 14px 0;
  font-size: 15px;
  text-align: center;
  border: 1px solid var(--color-primary);
  border-radius: var(--radius);
  color: var(--color-primary);
}
@media (max-width: 768px) {
  .site-header { padding-top: var(--safe-top); }
  .menu-btn { display: flex; }
  .main-nav, .header-right { display: none !important; }
  .domain-pc { display: none; }
  .header-inner { padding: 10px 12px; }
  .logo { font-size: 18px; }
  .nav-overlay { display: block; }
  .nav-drawer { display: flex; }
}
</style>
